<nav class="navbar navbar-expand-md navbar-dark bg-primary">
  <div class="container">
    <a class="navbar-brand" href="./">
      <img src="{{assetPath}}/icons/applogo.png" width="30" height="30" alt=""> {{'APPTITLE'|translate}}
    </a>

    <button type="button" class="navbar-toggler" data-toggle="collapse" data-target="#mainNavbarContent"
      aria-controls="mainNavbarContent" aria-expanded="false" aria-label="Toggle navigation"
      (click)="isNavbarCollapsed = !isNavbarCollapsed">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" [ngbCollapse]="isNavbarCollapsed" id="mainNavbarContent">
      <ul *ngIf="routes.children.length" class="navbar-nav ml-auto">

        <li class="nav-item" [class.active]="isCurrent(rootelement)" [class.dropdown]="rootelement.children.length"
          *ngFor="let rootelement of routes.children">

          <a *ngIf="hasNoChildren(rootelement)" class="nav-link" routerLink="/{{rootelement.route}}"
            (click)="isNavbarCollapsed = !isNavbarCollapsed">{{rootelement.text}}
            <span *ngIf="isCurrent(rootelement)" class="sr-only">(current)</span>
          </a>

          <div *ngIf="rootelement.children.length" ngbDropdown>
            <a ngbDropdownToggle class="nav-link dropdown-toggle" id="nav_dropdown">{{rootelement.text}}</a>
            <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="nav_dropdown">
              <a *ngFor="let child of rootelement.children" class="dropdown-item" routerLink="/{{child.route}}"
                (click)="isNavbarCollapsed = !isNavbarCollapsed">{{child.text}}</a>
            </div>
          </div>

        </li>

      </ul>
    </div>

  </div>
</nav>